import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

const Modal = ({
    modalname = "open dialog",
    modalstyle = "text-gray-500 underline  hover:text-gray-300",
    dialogTitle = "모달제목",
    dialogContent = "모달내용",
    dialogButton = "버튼명"
}: any) => {
    const [isOpen, setIsOpen] = useState(false);
    function closeModal() {
        setIsOpen(false);
    }
    function openModal() {
        setIsOpen(true);
    }

    return (
        <>
            <button type="button" className={modalstyle} onClick={openModal}>
                {modalname}
            </button>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-[9999]"
                    onClose={closeModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 flex justify-center sm:items-center sm:p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="flex h-full w-full max-w-2xl transform flex-col overflow-hidden bg-white text-left shadow-xl transition-all sm:h-auto sm:max-h-[85vh] sm:rounded-2xl">
                                <Dialog.Title
                                    as="h3"
                                    className="relative flex shrink-0 items-center justify-center border-b border-gray-200 px-14 py-4 text-lead font-semibold text-gray-900"
                                >
                                    <span>{dialogTitle}</span>
                                    <button
                                        type="button"
                                        aria-label="닫기"
                                        onClick={closeModal}
                                        className="absolute right-5 sm:right-6"
                                    >
                                        <XMarkIcon className="h-6 w-6" />
                                    </button>
                                </Dialog.Title>

                                <div className="flex-1 overflow-y-auto px-5 py-4 text-caption text-gray-500 sm:px-6">
                                    {dialogContent}
                                </div>

                                <div className="shrink-0 border-t border-gray-200 px-5 py-4 sm:px-6">
                                    <button
                                        type="button"
                                        className="hocus:bg-brand w-full rounded-md bg-brand-dark px-8 py-3 text-body font-medium text-gray-100 transition duration-300 focus:outline-none"
                                        onClick={closeModal}
                                    >
                                        {dialogButton}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
};

export default Modal;
